import React from 'react';
import { CoffeeHero } from '../components/coffee/CoffeeHero';
import { CoffeeStats } from '../components/coffee/CoffeeStats';
import { HowCarbonSafeWorks } from '../components/HowCarbonSafeWorks';
import { CoffeeJourney } from '../components/coffee/CoffeeJourney';
import { CoffeeFeatures } from '../components/coffee/CoffeeFeatures';
import { CoffeeRegulation } from '../components/coffee/CoffeeRegulation';
import { CoffeeCTA } from '../components/coffee/CoffeeCTA';
import { Footer } from '../components/Footer';
export function CoffeeTraceability() {
  return <>
      <CoffeeHero data-id="element-1212" />
      <CoffeeStats data-id="element-1213" />
      <HowCarbonSafeWorks verticalName="coffee traceability" subtext="From farmer's phone to EU importer's desk, four steps to a verified Digital Quality Certificate." steps={[{
      icon: 'SmartphoneIcon',
      title: 'USSD Data Capture',
      description: 'Farmers log harvest details, GPS coordinates, and quality grades via USSD on any phone.'
    }, {
      icon: 'ShieldCheckIcon',
      title: 'Independent Verification',
      description: 'CarbonSafe cross-references farm data with satellite imagery and cooperative records.'
    }, {
      icon: 'FileTextIcon',
      title: 'Digital Quality Certificate',
      description: 'A tamper-proof certificate is generated with origin, grade, and compliance status.'
    }, {
      icon: 'GlobeIcon',
      title: 'EUDR Market Access',
      description: 'EU importers scan and verify certificates to meet deforestation regulation requirements.'
    }]} data-id="element-1214" />
      <CoffeeJourney data-id="element-1215" />
      <CoffeeFeatures data-id="element-1216" />
      <CoffeeRegulation data-id="element-1217" />
      <CoffeeCTA data-id="element-1218" />
      <Footer data-id="element-1219" />
    </>;
}